import axios from 'axios';
import rest from './rest';

const API_URL = window.config.API_URL;
const BUILDER_ID = window.config.BUILDER_ID;

let actions = {

  get(url, data){
    if (!data) {
      data = {};
    }
    data.builder_id = BUILDER_ID;

    return axios({
      method:'get',
      url:getUrl(url) + '?' + queryString(data),
      data: data
    });
  },
  getUrl(url, data){
    console.log( data)
    return axios({
      method:'get',
      url:url + '?' + queryString(data),
      data: data
    });
  },
  getWithoutToken(url){
    return axios({
      method:'get',
      url:url,
    });
  },
  post(url, data){
    if (!data) {
      data = {};
    }
    data.builder_id = BUILDER_ID;
    return axios({
      method:'post',
      url:getUrl(url),
      data: data
    });
  },
  postUrl(url, data){
    return axios({
      method:'post',
      url:url,
      'Access-Control-Allow-Headers': 'x-access-token',
      data: queryString(data)
    });
  },
  sendMessage(obj){
    obj.builder_id = BUILDER_ID;
    return axios({
      method:'post',
      url:getUrl('create-message'),
      data: obj
    });
  },
  getAnnouncers(){
    return axios({
      method:'get',
      url:getUrl('announcers/?builder_id='+BUILDER_ID)
    });
  },
  getProgramming(){
    return axios({
      method:'get',
      url:getUrl('all-programming/?builder_id='+BUILDER_ID)
    });
  },
  getTokenChat(){
    return axios({
      method:'get',
      url:getUrl('chat-token/?builder_id='+BUILDER_ID)
    });
  }
}

function returnData(data){
  if (!data) {
    let data = {};
  }
  data.builder_id = BUILDER_ID;

  return data;
}

function getUrl(url) {
  return API_URL+url;
}

function queryString(obj) {
    let str = [];
    for (let p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}

export default actions



// WEBPACK FOOTER //
// ./src/service/api.js